import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "app-unified-load-docs-chip",
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  template: `
    <span
      class="inline-flex items-center justify-center rounded-full w-7 h-7 !min-w-fit"
      [ngClass]="chipClasses"
      [matTooltip]="tooltip"
    >
      <mat-icon
        svgIcon="heroicons_outline:document-duplicate"
        class="icon-size-4"
        [ngClass]="iconClasses"
      ></mat-icon>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnifiedLoadDocsChipComponent {
  @Input() hasUnifiedLoadDocs: boolean | null | undefined;

  get isUnified(): boolean {
    return !!this.hasUnifiedLoadDocs;
  }

  get tooltip(): string {
    return this.isUnified
      ? "Documentos de carga unificados"
      : "Sin documentos de carga unificados";
  }

  get chipClasses(): string {
    return this.isUnified
      ? "bg-blue-200 dark:bg-blue-600"
      : "bg-gray-200 dark:bg-gray-600";
  }

  get iconClasses(): string {
    return this.isUnified
      ? "text-blue-800 dark:text-blue-50"
      : "text-gray-500 dark:text-gray-300";
  }
}
